// sort-imports-ignore
/* eslint-disable import/first */
// Import polyfills and setup error reporting system
import "./_bootstrap";
import {
    Provider as ReactivatedProvider,
    getServerData,
    getTemplate,
} from "@reactivated";
import React from "react";
import { Provider as ReduxProvider } from "react-redux";
import { store } from "./store";
import { initPage } from "@thelabnyc/thelabui/src/index";
import { getDocument, getWindow } from "@thelabnyc/thelabui/src/utils/dom";

// Remove no-js class from HTML tag. On a full-document React page React owns
// <html className="no-js"> (rendered for the no-JS fallback), so an eager
// pre-hydration removal here would race hydration and mismatch -- those pages
// drop it post-hydration in PageSkeleton's effect instead. Island pages have a
// Django-rendered <html> with no hydration to race, so remove it eagerly.
const document = getDocument();
const _winNoJs = getWindow() as (Window & Record<string, unknown>) | null;
if (!_winNoJs?.["__PRELOADED_PROPS__"]) {
    const htmlElem = document?.querySelector("html");
    if (htmlElem) {
        htmlElem.classList.remove("no-js");
    }
}

// Load CSS
import "./styles/main.scss";

// Set tsi-common-react configuration
import "./localization";

const Provider = (props: React.ComponentProps<typeof ReactivatedProvider>) => {
    const { children, ...otherProps } = props;
    return (
        <ReactivatedProvider {...otherProps}>
            <ReduxProvider store={store}>{children}</ReduxProvider>
        </ReactivatedProvider>
    );
};

// In Vite dev mode, this module can execute twice under different URLs
// (bare vs ?t= cache-busted), causing double hydration. Guard against that.
const _w = getWindow() as (Window & Record<string, unknown>) | null;
if (!_w?.["__tsi_initPage"]) {
    if (_w) _w["__tsi_initPage"] = true;
    initPage({
        Provider,
        getServerData,
        getTemplate,
    }).catch((e) => {
        console.error(e);
    });
}

// Load legacy site components
import "./chunks/sentry";
import "./chunks/widgets";
import "./chunks/misc";
import "./chunks/modals";

import "./apps/checkout/index";
import "./apps/product-detail/index";
import "./apps/retail-locator/index";
import "./apps/reviews/index";
import "./init";

import "./chunks/analytics";
